<template>
		<div class="carousel-box bottom-padding overflow">
			<div class="title-box no-margin">
			<h1 class="title">{{ results.parent_name }}</h1>
			</div>
			
			<div class="clearfix"></div>
			
			<div class="row">
				<router-link :to="'/' + result.page_name " v-for="result in results.categories" :key="result.id" class="span4 product">
				<div class="product-image">
					<img :src="decodeURI(result.image_path)" alt="" title="">
				</div>
				<!-- <div class="product-description">
					<div class="vertical">
					<h3 class="product-name">{{result.title}}</h3>
					</div>
				</div> -->
				</router-link><!-- .product -->
				</div>
			</div>
</template>
<script>
//import axios from 'axios'
import Vue from 'vue'
import $ from 'jquery'
import {mapGetters, mapActions} from "vuex";
import Common from '@/common.js'
import OnLoad from 'vue-onload'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(OnLoad);
Vue.use(Vue2TouchEvents)



export default {
	name:'CategoryList',
   data: function(){
    return {
    results: [{parent_name:"",categories:[]}]
    }
  },  props: {
    msg: String
  },mounted: function() {

    //alert(this.$route.params.categoryId);
    this.loadOnMount();

    //axios.get("http://localhost/api/categories.php")
    //.then(response => {this.results = response.data})
    
  },
  computed:mapGetters(["Subcategories","Session","Cart","CartCount"]),
  watch: {
    Subcategories(newValue) { this.get_response(newValue)  },
    //Session(newValue) { this.get_session_response(newValue)  },
    //Cart(newValue) { this.response_cart_items(newValue)  },
    //CartCount(newValue) { this.results.cart_count = newValue  },
    $route() {
        // react to route changes...
        this.loadOnMount()
        //alert(this.$route.query.pg);
    }
  },methods:{
          ...mapActions(["getSubCategories","getCart"]),
          loadOnMount: function()
          {
              this.getSubCategories(this.$route.params.categoryId);
              //Common.callServerFunction("Items/ItemController::GetCategoryItems",this.get_response,{'category':this.$route.params.categoryId},"Item");
          },   
          touchHandler (event) {
            
            var purl =  $(event.target).attr('href');
            if(purl != undefined)
            {
              this.$router.push(purl);
            }else
            {
              purl = $(event.target).parent().attr('href');
              this.$router.push(purl);
            }

            //console.log($(event.target).parent())  // May be left / right / top / bottom
        },
          get_response:function(response)
          {	
            var rdata = response;
            this.results = rdata;
            if(rdata.parent_name == ""){
                //this.$router.push("/404");
            }
                var jimage = [];
                Common.startAjaxLoader();
                rdata.categories.forEach((item) => {
                    //console.log(item.image_path + " - " + index);
                    jimage.push(item.image_path)
                });
                this.preload = false
                this.$nextTick(function() {
                  this.$images.preload(jimage,
                    (completed, progress) => {
                      // progress indicator from 0 (no image loaded yet) to 1 (all images loaded)
                      console.log(Math.round(progress * 100))
                      // completed = true when all images are loaded
                      if (completed) {
                        this.preload = true
                        console.log(completed);
                        eval('loadFunctions();');
                        Common.stopAjaxLoader();
                      }
                    }
                  )
                })

                //$(".item").eq(0).addClass('item active');


                          //$.get('./js/main.js', function(data) {
                        //eval(data);
                        //eval('setTimeout(loadFunctions(),1000);');

                //});
                
         }   
   }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
